import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import * as actions from '~actions/payment';
import BaseSetup from '~pages/payment/long-tail/setup/base';
import DepositModal from '~pages/payment/long-tail/setup/deposit/deposit-modal';
import DepositTable from '~pages/payment/long-tail/setup/table/deposit-table';
import { Add } from '~components/svgs';
const mapDispatchToProps = dispatch => ({
  createOrderDeposit: (params, onSuccess) => {
    dispatch(actions.createOrderDeposit(params, onSuccess));
  },
  createOrderFee: (params, onSuccess) => {
    dispatch(actions.createOrderFee(params, onSuccess));
  },
  updateOrderDeposit: (params, onSuccess, onError) => {
    dispatch(actions.updateOrderDeposit(params, onSuccess, onError));
  },
  deleteOrderDeposit: (params, onSuccess) => {
    dispatch(actions.deleteOrderDeposit(params, onSuccess));
  },
  updateOrderFee: (params, onSuccess, onError) => {
    dispatch(actions.updateOrderFee(params, onSuccess, onError));
  },
  deleteOrderFee: (params, onSuccess) => {
    dispatch(actions.deleteOrderFee(params, onSuccess));
  },
});
@connect(null, mapDispatchToProps)
@withTranslation()
export default class Deposit extends BaseSetup {
  constructor() {
    super();

    this.state = {
      showDepositeModal: false,
      selectRecord: null,
      disableDelBtn: false,
    };
  }

  handleDepositModal = trigger => {
    if (!trigger) {
      this.state.selectRecord = null;
    }
    this.state.showDepositeModal = trigger;
    this.setState(this.state);
  };

  handleSubmitModal = (value, type, callback) => {
    const { payThroughStcom } = value;
    if (this.props.paymentPlan) {
      if (this.state.selectRecord) {
        if (type === 'deposit') {
          this.props.updateOrderDeposit(
            {
              ...value,
              id: this.state.selectRecord.id,
              amount: value.amount.toString(10),
            },
            () => {
              callback();
              this.props.getPaymentPlan({
                id: this.props.paymentPlan.id,
              });
              this.handleDepositModal(false);
            },
            callback,
          );
        } else {
          this.props.updateOrderFee(
            {
              ...value,
              id: this.state.selectRecord.id,
              amount: value.amount.toString(10),
            },
            () => {
              callback();
              this.props.getPaymentPlan({
                id: this.props.paymentPlan.id,
              });
              this.handleDepositModal(false);
            },
            callback,
          );
        }
      } else {
        if (payThroughStcom) {
          this.props.createOrderDeposit(
            {
              ...value,
              paymentPlanId: this.props.paymentPlan.id,
              amount: value.amount.toString(10),
            },
            () => {
              callback();
              this.props.getPaymentPlan({
                id: this.props.paymentPlan.id,
              });
              this.handleDepositModal(false);
            },
          );
        } else {
          this.props.createOrderFee(
            {
              ...value,
              paymentPlanId: this.props.paymentPlan.id,
              amount: value.amount.toString(10),
            },
            () => {
              callback();
              this.props.getPaymentPlan({
                id: this.props.paymentPlan.id,
              });
              this.handleDepositModal(false);
            },
          );
        }
      }
    }
  };

  handleEditDeposit = record => {
    this.setState({
      selectRecord: record,
      showDepositeModal: true,
    });
  };

  handleDeleteDeposit = record => {
    const { type } = record;
    if (this.state.disableDelBtn) {
      return false;
    }
    this.setState({ disableDelBtn: true });
    if (type === 'deposit') {
      this.props.deleteOrderDeposit(
        {
          id: record.id,
        },
        () => {
          this.setState({ disableDelBtn: false });
          this.props.getPaymentPlan({
            id: this.props.paymentPlan.id,
          });
        },
      );
    } else {
      this.props.deleteOrderFee(
        {
          id: record.id,
        },
        () => {
          this.setState({ disableDelBtn: false });
          this.props.getPaymentPlan({
            id: this.props.paymentPlan.id,
          });
        },
      );
    }

    return true;
  };

  createDataSource = paymentPlan => {
    const { deposits, fees } = paymentPlan;
    deposits.forEach((deposit, index) => {
      if (index == 0) {
        deposit.cannotDelete = true;
      }
      deposit.type = 'deposit';
      deposit.timestamp = Date.parse(new Date(deposit.createdAt));
    });
    fees.forEach(fee => {
      fee.type = 'fee';
      fee.timestamp = Date.parse(new Date(fee.createdAt));
    });
    const newArr = deposits.concat(fees).sort((a, b) => b.timestamp - a.timestamp);
    return newArr;
  };
  render() {
    const { t, paymentPlan, isMustPayDespositFee, paymentOnline } = this.props;

    const depositAndFeesDatas = paymentPlan ? this.createDataSource(paymentPlan) : [];
    // paymentOnline有null，true时不需要设置disabled，只有paymentOnline为false时，需要设置disabled
    const isPaytoStudentBtnDisabled =
      (isMustPayDespositFee && !paymentPlan?.deposits?.length) || !paymentOnline;
    return (
      <div className="long-tail__deposit">
        <h2 className="long-tail__deposit__title">
          {t('landlord.payment.long_tail.deposit_fee.title')}
        </h2>
        <p className="long-tail__deposit__summary">
          {t('landlord.payment.long_tail.deposit.tips')}
        </p>
        <button
          className="long-tail__deposit__btn long-tail__deposit__btn--add-new-plan"
          onClick={() => {
            this.handleDepositModal(true);
          }}
        >
          <Add style={{ width: '14px', fill: '#38B2A6', verticalAlign: '-2px' }} />{' '}
          {t('landlord.payment.long_tail.add_new_fee_deposit.btn')}
        </button>

        <DepositTable
          t={t}
          onEdit={this.handleEditDeposit}
          onDelete={this.handleDeleteDeposit}
          dataSource={depositAndFeesDatas}
          currency={this.props.paymentPlan ? this.props.paymentPlan.currency : ''}
          isMustPayDespositFee={isMustPayDespositFee}
        />

        <If condition={this.state.showDepositeModal}>
          <DepositModal
            t={t}
            onClose={this.handleDepositModal}
            onSubmit={this.handleSubmitModal}
            deposit={this.state.selectRecord}
            currency={this.props.paymentPlan ? this.props.paymentPlan.currency : ''}
            isPaytoStudentBtnDisabled={isPaytoStudentBtnDisabled}
            paymentOnline={paymentOnline}
            activeModal
          />
        </If>
      </div>
    );
  }
}

Deposit.propTypes = {
  t: PropTypes.func.isRequired,
  isMustPayDespositFee: PropTypes.bool,
};
Deposit.defaultProps = {
  t: () => {},
  isMustPayDespositFee: false,
};
